import { LitElement, html } from 'lit';

import componentStyles from './fil-accordion.styles.js';

/**
 * Wrapper component for Accordion items
 * @tag fil-accordion
 * @property {boolean} [multiPanel=false] Whether if more than one accordion item can be open at the same time or not
 */
export class FilAccordion extends LitElement {
  static properties = {
    multiPanel: { type: Boolean },
    _panels: { type: Array, state: true },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.multiPanel = false;

    this.initialized = false;
    this._panels = [];
  }

  shouldUpdate(changedProperties) {
    if (!this.initialized) {
      this._panels = Array.from(this.children);
      // this._panels.map(panel => panel.setAttribute('tabIndex', '0'));
      this.initialized = true;
    }
    return changedProperties;
  }

  handleChildClick(event) {
    event.preventDefault();
    if (event.detail && event.detail.innerAction) {
      this.handleClick(event);
    }
  }

  handleChildKeyup(event) {
    event.preventDefault();
    if (event.detail && event.detail.innerAction) {
      this.handleKeyup(event);
    }
  }

  updatePanels(target) {
    this._panels.map(panel => {
      if (!this.multiPanel && panel.hasAttribute('expanded') && panel !== target) {
        panel.removeAttribute('expanded');
        panel.removeAttribute('aria-expanded');
      }

      if (panel === target) {
        if (panel.hasAttribute('expanded')) {
          panel.removeAttribute('expanded');
          panel.removeAttribute('aria-expanded');
        } else {
          panel.setAttribute('expanded', 'true');
          panel.setAttribute('aria-expanded', 'true');
          panel.focus();
        }
      }
    });

    return this._panels;
  }

  setNextPanel(target) {
    if (target !== this._panels[this._panels.length - 1]) {
      return target.nextElementSibling;
    }
    return this._panels[0];
  }

  setPreviousPanel(target) {
    if (target !== this._panels[0]) {
      return target.previousElementSibling;
    }
    return this._panels[this._panels.length - 1];
  }

  handleKeyup(event) {
    let { target } = event;
    switch (event.detail.key) {
      case 'Tab':
        if (event.shiftKey) {
          target = this.setPreviousPanel(target);
        } else {
          target = this.setNextPanel(target);
        }
        break;
      case 'Down':
      case 'ArrowDown':
        target = this.setNextPanel(target);
        break;
      case 'Up':
      case 'ArrowUp':
        target = this.setPreviousPanel(target);
        break;
      case 'Enter':
      case 'Space':
        this.updatePanels(target);
        break;
      default:
        break;
    }

    target.focus();
  }

  handleClick(event) {
    const { target } = event;
    this.updatePanels(target);
  }

  render() {
    return html`<div
      class="fil-accordion"
      @click.gds.accordion=${this.handleChildClick}
      @keyup.gds.accordion=${this.handleChildKeyup}
    >
      <slot></slot>
    </div>`;
  }
}

export default FilAccordion;
